/** Pastel avatar backgrounds when OAuth doesn't provide a photo/color. */
export const AVATAR_PASTELS = [
  '#9CAF88', // sage
  '#A8B5C4', // mist blue
  '#C4A484', // sand
  '#B8A9C9', // lilac
  '#E8A0A0', // blush
  '#8FB9A8', // seafoam
  '#D4B483', // honey
  '#9BB7D4', // sky
] as const;

export function hashString(input: string): number {
  let h = 0;
  for (let i = 0; i < input.length; i += 1) {
    h = (h * 31 + input.charCodeAt(i)) >>> 0;
  }
  return h;
}

export function avatarPastelFor(seed: string | null | undefined): string {
  const key = (seed || 'guest').trim().toLowerCase() || 'guest';
  return AVATAR_PASTELS[hashString(key) % AVATAR_PASTELS.length];
}

/** Prefer Google/Apple display name; never show raw email as the primary label. */
export function resolveDisplayName(
  displayName: string | null | undefined,
  email: string | null | undefined,
): string {
  const name = displayName?.trim();
  if (name && !name.includes('@')) return name;
  if (email?.includes('@')) {
    const local = email.split('@')[0]?.trim();
    if (local) return local;
  }
  if (name) return name;
  return 'Guest';
}

export function avatarInitial(displayName: string): string {
  const cleaned = displayName.trim();
  if (!cleaned) return '?';
  const first = cleaned.split(/\s+/)[0] || cleaned;
  return first.charAt(0).toUpperCase();
}

export function formatPlanLabel(plan: string | null | undefined): string {
  const raw = (plan || 'free').trim().toLowerCase();
  if (!raw || raw === 'free') return 'Free';
  if (raw === 'basic') return 'Basic';
  if (raw === 'pro') return 'Pro';
  if (raw === 'enterprise') return 'Enterprise';
  return raw.charAt(0).toUpperCase() + raw.slice(1);
}
